/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'email': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M3.052 4.25A1.75 1.75 0 001.302 6v11c0 .966.783 1.75 1.75 1.75h17.991a1.75 1.75 0 001.75-1.75V6a1.75 1.75 0 00-1.75-1.75H3.052zm-.25 2.331V17c0 .138.112.25.25.25h17.991a.25.25 0 00.25-.25V6.547l-8.879 5.493-.394.244-.395-.244L2.802 6.58zM19.73 5.75H4.31l7.71 4.77 7.71-4.77z" _fill="#000"/>'
  }
})
